// content-profile-form.ts — (audit 10-14) the create form's content profile, pure so it can be tested.
// Before TF3-6a the form filled a blank with "General", "General audience" or "Follow for more" and saved that to the
// browser; a profile saved then would still be loaded and sent as if typed. Those exact values are dropped on load.
import type { ContentProfile } from "@vms/tubeforge-shared";

const INVENTED: Partial<Record<"channelNiche" | "targetAudience" | "callToAction", string>> = {
  channelNiche: "General", targetAudience: "General audience", callToAction: "Follow for more",
};

/** A saved profile without the values the old form invented. */
export function cleanSavedProfile(p: Partial<ContentProfile>): Partial<ContentProfile> {
  const out = { ...p };
  for (const [k, v] of Object.entries(INVENTED) as [keyof typeof INVENTED, string][]) if (out[k] === v) delete out[k];
  return out;
}

/** Whether the customer stated anything a profile carries: the three basics, or the product's own fields. */
export function hasProfileInput(f: { channelNiche: string; targetAudience: string; callToAction: string; productName: string;
    differentiator: string; sellingPoints: string[]; painPoints: string[] }): boolean {
  return !!(f.channelNiche.trim() || f.targetAudience.trim() || f.callToAction.trim() || f.productName.trim()
    || f.differentiator.trim() || f.sellingPoints.length || f.painPoints.length);
}
